import { role } from 'utilities/enum'
import Menu from './Menu'

export default function ParentMenu() {
    return (<Menu items={[
        ['/home', 'faHouse', 'Home'],
        ['/home/packages', 'faBox', 'Paquetes'],
        ['/home/users/student', 'faUsers', 'Usuarios'],
        ['/home/payment', 'faHandHoldingDollar', 'Pagos'],
        ['/home/support', 'faHeadset', 'Apoyo']
    ]} />)
}